;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.profile', []).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('profile', {
      url: '/profile',
      parent: 'portal',
      templateUrl: 'profile.html',
      controller: 'Profile',
      controllerAs: '$ctrl',
      title: 'Profile',
    })
  }
})()
